const endpoint = property => `/api/${property}/orders`;
const statusEndpoint = property => `/api/${property}/statuses`;

export default ['api', function (api) {
    return {
        save: order => {
            let url = order.id ? `${endpoint(api.property())}/${order.id}` : endpoint(api.property());

            return api.upload(url, order).then(response => response.data);
        },
        delete: id => api.delete(`${endpoint(api.property())}/${id}`),
        findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
            return api.get(endpoint(api.property()) + (page ? '?page=' + (page) + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).
                then(response => response.data);
        },
        findPayment: (page = undefined, perpage = undefined) => {
            return api.get(`${endpoint(api.property())}?notCheckout=true${(page ? '&page=' + (page) + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '')}`).
                then(response => response.data);
        },
        findById: id => {
            return api.get(`${endpoint(api.property())}/${id}`)
                .then(response => response.data);
        },
        search: (type, text, viewDeleted = false) => {
            return api.get(`${endpoint(api.property())}?type=${type}&text=${text}&viewDeleted=${viewDeleted}`).then(response => response.data);
        },
        getOrderStatuses: () => {
            return api.get(`${statusEndpoint(api.property())}/orders`).then(response => response.data);
        },
        getPaymentStatuses: () => {
            return api.get(`${statusEndpoint(api.property())}/payments`).then(response => response.data);
        },
        sendEmail: (orderId, sendTo) => {
            return api.post(`${endpoint(api.property())}/${orderId}/email`, {
                emailType: sendTo,
                noAdmin: sendTo === 'customer' ? true : undefined
            });
        },
        getEmailContent: (orderId, template) => {
            return api.get(`${endpoint(api.property())}/${orderId}/email/view?template=${template}`);
        },
        generateOrder: (basketCode) => {
            return api.get(`${endpoint(api.property())}/generate/${basketCode}`);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/services/orders.api.service.js